var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArchived = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M100 100v30c0 5.523 4.477 10 10 10h60c5.523 0 10-4.477 10-10v-30h60v130c0 5.523-4.477 10-10 10H50c-5.523 0-10-4.477-10-10V100zm140-60c5.523 0 10 4.477 10 10v20c0 5.523-4.477 10-10 10H40c-5.523 0-10-4.477-10-10V50c0-5.523 4.477-10 10-10z"
})));
export default SvgArchived;